
















import { IDictionary } from '@/shared/models/interface/dictionary-model';
import { defineComponent, PropType } from '@vue/composition-api'

export default defineComponent({
    name: "SelectAtom",
    computed: {
        selection: {
            get(): string {
                return this.selected
            },
            set(value: string) {
                this.$emit('change', value)
            }
        }
    },
    props: {
        label: {
            type: String
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        options: {
            type: Object as PropType<IDictionary<string>>,
            required: true
        },
        selected: {
            type: String,
            default: ''
        }
    }
})
